export const CATALOGUE_LOADERS = {
    en: {
        common: () => import('./messages/en/common'),
        shell: () => import('./messages/en/shell'),
        auth: () => import('./messages/en/auth'),
        errors: () => import('./messages/en/errors'),
        validation: () => import('./messages/en/validation'),
        enum: () => import('./messages/en/enum'),
        print: () => import('./messages/en/print'),
        notifications: () => import('./messages/en/notifications'),
        settings: () => import('./messages/en/settings'),
        patients: () => import('./messages/en/patients'),
        portal: () => import('./messages/en/portal'),
        queue: () => import('./messages/en/queue'),
        admin: () => import('./messages/en/admin'),
        billing: () => import('./messages/en/billing'),
        opd: () => import('./messages/en/opd'),
        pharmacy: () => import('./messages/en/pharmacy'),
        lab: () => import('./messages/en/lab'),
        radiology: () => import('./messages/en/radiology'),
        ipd: () => import('./messages/en/ipd'),
        server: () => import('./messages/en/server'),
    },
    ar: {
        common: () => import('./messages/ar/common'),
        shell: () => import('./messages/ar/shell'),
        auth: () => import('./messages/ar/auth'),
        errors: () => import('./messages/ar/errors'),
        validation: () => import('./messages/ar/validation'),
        enum: () => import('./messages/ar/enum'),
        print: () => import('./messages/ar/print'),
        notifications: () => import('./messages/ar/notifications'),
        settings: () => import('./messages/ar/settings'),
        patients: () => import('./messages/ar/patients'),
        portal: () => import('./messages/ar/portal'),
        queue: () => import('./messages/ar/queue'),
        admin: () => import('./messages/ar/admin'),
        billing: () => import('./messages/ar/billing'),
        opd: () => import('./messages/ar/opd'),
        pharmacy: () => import('./messages/ar/pharmacy'),
        lab: () => import('./messages/ar/lab'),
        radiology: () => import('./messages/ar/radiology'),
        ipd: () => import('./messages/ar/ipd'),
        server: () => import('./messages/ar/server'),
    },
    es: {
        common: () => import('./messages/es/common'),
        shell: () => import('./messages/es/shell'),
        auth: () => import('./messages/es/auth'),
        errors: () => import('./messages/es/errors'),
        validation: () => import('./messages/es/validation'),
        enum: () => import('./messages/es/enum'),
        print: () => import('./messages/es/print'),
        notifications: () => import('./messages/es/notifications'),
        settings: () => import('./messages/es/settings'),
        patients: () => import('./messages/es/patients'),
        portal: () => import('./messages/es/portal'),
        queue: () => import('./messages/es/queue'),
        admin: () => import('./messages/es/admin'),
        billing: () => import('./messages/es/billing'),
        opd: () => import('./messages/es/opd'),
        pharmacy: () => import('./messages/es/pharmacy'),
        lab: () => import('./messages/es/lab'),
        radiology: () => import('./messages/es/radiology'),
        ipd: () => import('./messages/es/ipd'),
        server: () => import('./messages/es/server'),
    },
    'ur-Latn': {
        common: () => import('./messages/ur-Latn/common'),
        shell: () => import('./messages/ur-Latn/shell'),
        auth: () => import('./messages/ur-Latn/auth'),
        errors: () => import('./messages/ur-Latn/errors'),
        validation: () => import('./messages/ur-Latn/validation'),
        enum: () => import('./messages/ur-Latn/enum'),
        print: () => import('./messages/ur-Latn/print'),
        notifications: () => import('./messages/ur-Latn/notifications'),
        settings: () => import('./messages/ur-Latn/settings'),
        patients: () => import('./messages/ur-Latn/patients'),
        portal: () => import('./messages/ur-Latn/portal'),
        queue: () => import('./messages/ur-Latn/queue'),
        admin: () => import('./messages/ur-Latn/admin'),
        billing: () => import('./messages/ur-Latn/billing'),
        opd: () => import('./messages/ur-Latn/opd'),
        pharmacy: () => import('./messages/ur-Latn/pharmacy'),
        lab: () => import('./messages/ur-Latn/lab'),
        radiology: () => import('./messages/ur-Latn/radiology'),
        ipd: () => import('./messages/ur-Latn/ipd'),
        server: () => import('./messages/ur-Latn/server'),
    },
};
export async function loadCatalogue(locale, namespace) {
    const loader = CATALOGUE_LOADERS[locale]?.[namespace];
    if (!loader)
        return {};
    return (await loader()).default;
}
export function catalogueCompleteness(source, target, allowlist = new Set()) {
    const missing = Object.keys(source).filter((key) => !(key in target) && !allowlist.has(key));
    return { complete: missing.length === 0, missing };
}
//# sourceMappingURL=catalogue.js.map